import { API_BASE, apiClient } from "./client";

export interface ArtifactUploadResponse {
  id: string;
  download_url: string;
  filename: string;
  media_type: string;
}

export async function uploadArtifact(file: File): Promise<ArtifactUploadResponse> {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post<ArtifactUploadResponse>("/artifacts", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export function artifactDownloadUrl(token: string, filename?: string): string {
  const qs = filename ? `?filename=${encodeURIComponent(filename)}` : "";
  return `${API_BASE}/artifacts/${encodeURIComponent(token)}${qs}`;
}
